import React, { useState, useEffect } from "react";
import {
  FiUser,
  FiCheckCircle,
  FiPhoneCall,
  FiUsers,
  FiMail,
  FiRepeat,
  FiMonitor,
  FiFileText,
  FiUserPlus,
  FiAward,
  FiBarChart2,
} from "react-icons/fi";
import { BsWhatsapp } from "react-icons/bs";
import { useGetEssentials } from "../../../Utils/hooks/useGetEssentials";
import { GetRequest } from "../../../Utils/hooks/ApiHandler";
import { COLORS } from "./myDashboardConstants";
import { CSS } from "./styles";
import { SectionCard, SectionCard3 } from "./components/SectionCards";
import { MiniWinGauge } from "./components/MiniWinGauge";
import { MonthlyTargetRadial } from "./sections/MonthlyTargetRadial";
import { SalesFunnel } from "./sections/SalesFunnel";
import { PipelineDistribution } from "./sections/PipelineDistribution";
import { LeadSources, WIN_RATE } from "./sections/LeadSources";
import { HotLeadsTable } from "./sections/HotLeadsTable";
import { RecentDealsTable } from "./sections/RecentDealsTable";
import { Button } from "react-bootstrap";
import Select from "react-select";
export const MyDashboard = () => {
  const { headers, extras, customerId, loginUserId } = useGetEssentials();
  const [loading, setLoading] = useState(false);
  const [salesperson, setSalesperson] = useState("All Salespersons");
  const [outReachData, setOutReachData] = useState([]);
  const [leadSourceRange, setLeadSourceRange] = useState("This Month");
  const [recentDealData, setRecentDealData] = useState([]);
  const [recentDealRange, setRecentDealRange] = useState("This Month");
  const [recentLeadData, setRecentLeadData] = useState([]);
  const [recentLeadRange, setRecentLeadRange] = useState("This Month");
  const [salesFunnelData, setFunnelData] = useState([]);
  const [saleFunnelRange, setSaleFunnelRange] = useState("This Month");
  const [activitySummary, setActivitySummary] = useState([]);
  const [topLeadSourceBySale, setTopLeadSourceBySale] = useState([]);
  const [personalKpiData, setPersonalKpiData] = useState([]);
  const [pipelines, setPipelines] = useState([]);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [pipelineDistData, setPipelineDistData] = useState([]);
  const [leadOwners, setLeadOwners] = useState([]);
  const [selectedOwnerId, setSelectedOwnerId] = useState(null);
  // effectiveUserId = jo bhi dropdown me select hoga, wahi id har API me jaayegi.
  // Jab tak owner select nahi hota (ya list empty hai), login user ki id fallback rahegi.
  const effectiveUserId = selectedOwnerId || loginUserId;
  // function to fetch owners for the dropdown
  const fetchOwners = async () => {
    try {
      const res = await GetRequest(
        `users/users/fetchUserAsOwner/${customerId}`,
        { headers },
        extras,
      );
      if (res?.status === "fail" || res?.success === false) {
        return;
      }
      const owners = (res?.data || []).map((lead) => ({
        leadName: lead.full_name,
        leadId: lead.id,
      }));
      setLeadOwners(owners);
      // default: login user hi selected rahega agar list me mile,
      // warna list ka pehla owner, warna login user id as-is
      setSelectedOwnerId((prev) => {
        if (prev) return prev;
        const loggedInMatch = owners.find(
          (o) => String(o.leadId) === String(loginUserId),
        );
        if (loggedInMatch) return loggedInMatch.leadId;
        return owners[0]?.leadId || loginUserId;
      });
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchOwners();
  }, [customerId]);
  // react-select ke liye options format {value, label}
  const ownerOptions = leadOwners.map((owner) => ({
    value: owner.leadId,
    label:
      String(owner.leadId) === String(loginUserId)
        ? `${owner.leadName} (You)`
        : owner.leadName,
  }));
  const selectedOwnerOption =
    ownerOptions.find((opt) => String(opt.value) === String(selectedOwnerId)) ||
    null;
  // screenshot jaisa look: rounded, thin border, small font, blue border on focus
  const ownerSelectStyles = {
    container: (base) => ({ ...base, minWidth: "220px", maxWidth: "260px" }),
    control: (base, state) => ({
      ...base,
      minHeight: "38px",
      borderRadius: "6px",
      borderColor: state.isFocused ? COLORS.primary : "#dcdfe6",
      boxShadow: state.isFocused ? `0 0 0 1px ${COLORS.primary}` : "none",
      fontSize: "13px",
      cursor: "pointer",
      "&:hover": { borderColor: COLORS.primary },
    }),
    valueContainer: (base) => ({ ...base, padding: "2px 10px" }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({ ...base, padding: "6px" }),
    menu: (base) => ({ ...base, fontSize: "13px", zIndex: 20 }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? COLORS.primary
        : state.isFocused
          ? COLORS.primarySoft
          : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      cursor: "pointer",
    }),
    placeholder: (base) => ({ ...base, color: "#9aa1a9" }),
  };
  // function to fetch outreach records
  const fetchOutReach = async () => {
    setOutReachData([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/outreachActivity/${effectiveUserId}/${customerId}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") {
        return;
      }
      if (res?.status === "success") {
        setOutReachData(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  // function to fetch activity summary
  const fetchActivity_summary = async () => {
    setActivitySummary([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/activitySummary/${effectiveUserId}/${customerId}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") {
        return;
      }
      if (res.status === "success") {
        setActivitySummary(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  //function to fetch top sales by lead source
  const RANGE_TO_TYPE = {
    "This Month": "month",
    "This Quarter": "quarter",
    "This Year": "year",
  };
  const fetchTopLeadSourceBySales = async ({ type = "month" } = {}) => {
    setTopLeadSourceBySale([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/topLeadsSource/${effectiveUserId}/${customerId}/${type}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") {
        return;
      }
      if (res?.status === "success") {
        setTopLeadSourceBySale(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTopLeadSourceBySales({
      type: RANGE_TO_TYPE[leadSourceRange] || "month",
    });
  }, [customerId, leadSourceRange, effectiveUserId]);
  //function to fetch personal kpi
  const fetchPersonalKpi = async () => {
    setPersonalKpiData([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/personalKPI/${effectiveUserId}/${customerId}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") {
        return;
      }
      if (res?.status === "success") {
        setPersonalKpiData(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  //function to fetch recent deal
  const recent_deal_type = {
    "This Month": "month",
    "This Quarter": "quarter",
    "This Year": "year",
  };
  const fetchRecentDeal = async ({ type = "month" } = {}) => {
    setRecentDealData([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/recentDeals/${effectiveUserId}/${customerId}/${type}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") {
        return;
      }
      if (res?.status === "success") {
        setRecentDealData(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchRecentDeal({
      type: recent_deal_type[recentDealRange] || "month",
    });
  }, [customerId, recentDealRange, effectiveUserId]);
  //function to fetch recent (hot) leads
  const recent_lead_type = {
    "This Month": "month",
    "This Quarter": "quarter",
    "This Year": "year",
  };
  const fetchRecentLead = async ({ type = "month" } = {}) => {
    setRecentLeadData([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/hotLeads/${effectiveUserId}/${customerId}/${type}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") {
        return;
      }
      if (res?.status === "success") {
        setRecentLeadData(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchRecentLead({
      type: recent_lead_type[recentLeadRange] || "month",
    });
  }, [customerId, recentLeadRange, effectiveUserId]);
  //function to fetch sales funnel
  const sales_funnel_type = {
    "Today" :"today",
    "This Week":"week",
    "This Month": "month",
    "This Quarter": "quarter",
    "This Year": "year",
  };
  const fetchSalesFunnel = async ({ type = "month" } = {}) => {
    setFunnelData([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/salesFunnel/${effectiveUserId}/${customerId}/${type}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") {
        return;
      }
      if (res?.status === "success") {
        setFunnelData(res?.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSalesFunnel({
      type: sales_funnel_type[saleFunnelRange] || "month",
    });
  }, [customerId, saleFunnelRange, effectiveUserId]);
  //function to fetch pipelines (for the dropdown)
  const fetchPipelines = async () => {
    setPipelines([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/fetchPipelines/${effectiveUserId}/${customerId}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") return;
      if (res?.status === "success") {
        const list = res?.data || [];
        setPipelines(list);
        // default select first pipeline only if nothing selected yet
        setSelectedPipeline((prev) => prev || list[0] || null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  //function to fetch stage distribution for the selected pipeline
  const fetchPipelineDistribution = async (pipeline) => {
    if (!pipeline?.id || !pipeline?.module_name) return;
     setPipelineDistData([]);
    setLoading(true);
    try {
      const res = await GetRequest(
        `Sales_dashboard/pipelineDistribution/${effectiveUserId}/${customerId}/${pipeline.id}/${pipeline.module_name}`,
        { headers },
        extras,
      );
      if (res?.status !== "success" || res?.status === "fail") return;
      if (res?.status === "success") {
        setPipelineDistData(res?.data || []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedPipeline) {
      fetchPipelineDistribution(selectedPipeline);
    }
  }, [customerId, selectedPipeline, effectiveUserId]);
  useEffect(() => {
    fetchOutReach();
    fetchActivity_summary();
    fetchPersonalKpi();
    fetchPipelines();
  }, [customerId, effectiveUserId]);
  const renderTrendIndicator = (current, last) => {
    const currentVal = Number(current) || 0;
    const lastVal = Number(last) || 0;
    const diff = currentVal - lastVal;
    const isUp = diff >= 0;
    const isEq = diff === 0;
    const percentage = lastVal === 0
      ? (currentVal > 0 ? "100" : "0")
      : Math.abs((diff / lastVal) * 100).toFixed(0);
    return (
      <div
        className="sd-outreach-trend"
        style={{
          color: isEq ? COLORS.warning : isUp ? COLORS.success : COLORS.danger,
        }}
      >
        {isEq ? (
          `0% vs last week`
        ) : (
          <>
            {isUp ? "▲" : "▼"} {percentage}% vs last week
          </>
        )}
      </div>
    );
  };
  const renderActivityTrendIndicator = (current, last) => {
    const currentVal = Number(current) || 0;
    const lastVal = Number(last) || 0;
    const diff = currentVal - lastVal;
    const isUp = diff >= 0;
    const isEq = diff === 0;
    const percentage = lastVal === 0
      ? (currentVal > 0 ? "100" : "0")
      : Math.abs((diff / lastVal) * 100).toFixed(0);
    return (
      <div
        className="sd-kpi-trend-mini"
        style={{
          color: isEq ? COLORS.warning : isUp ? COLORS.success : COLORS.danger,
        }}
      >
        {isEq ? (
          `0% `
        ) : (
          <>
            {isUp ? "▲" : "▼"} {percentage}%
          </>
        )}
      </div>
    );
  };
  const win_rate = () => {
  // API se aane waali strings ('70', '9') ko Number mein badalna zaroori hai
  const allLead = Number(topLeadSourceBySale?.allLeads) || 0;
  const allDeal = Number(topLeadSourceBySale?.wonLeads) || 0;

  // Agar leads 0 hain toh 0.00% return karein
  if (allLead === 0) return "0.00%";

  // Agar won deals leads se zyada hain, toh 100% dikhayein (aapki request ke hisaab se)
  if (allDeal >= allLead) return "100.00%";

  // Normal calculation
  const ratio = (allDeal / allLead) * 100;
  return ratio.toFixed(2) + "%";
};

 


  return (
    <div className="sd-root mt-4">
      {/* {loading && <Spinner />} */}
      <style>{CSS}</style>
      <div
      >
        <div className="">
          <div className="d-flex justify-content-between mb-2">
            <Select
              options={ownerOptions}
              value={selectedOwnerOption}
              onChange={(opt) => setSelectedOwnerId(opt?.value)}
              placeholder="Select User"
              isSearchable
              styles={ownerSelectStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              className="sd-owner-select"
              classNamePrefix="sd-owner-select"
            />
            <input
              className="form-control h-100"
              type="text"
              placeholder='Search Here...'
              style={{ fontSize: "12px", paddingLeft: "36px", maxWidth: "240px" }}
            // onChange={(e) => {
            //     setInputSearch(e.target.value)
            //     setActiveOffset(0)
            // }}
            // onKeyDown={(e) => {
            //     if (e.key === "Enter") {
            //         e.preventDefault()
            //         setSearch(inputSearch)
            //         setActiveOffset(0)
            //     }
            // }}
            />
          </div>

          <div className="sd-shell">
            {/* Activity KPIs + Monthly Target */}
            <div className="row g-3 mb-3">
              <div className="col-lg-3">
                <SectionCard
                  title="Outreach Activity"
                  subtitle="Team communication today"
                  icon={<FiPhoneCall size={16} />}
                  accent={COLORS.primary}
                >
                  <div className="sd-outreach-list">
                    <div className="sd-outreach-row">
                      <div className="sd-outreach-left">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.primarySoft,
                            color: COLORS.primary,
                          }}
                        >
                          <FiPhoneCall size={16} />
                        </div>
                        <div>
                          <h3
                            className="fw-normal text-dark mb-0"
                            style={{ letterSpacing: "-0.02em" }}
                          >
                            {outReachData?.current_activity_calls}
                          </h3>
                          <div className="sd-kpi-label">Calls</div>
                        </div>
                      </div>
                      {renderTrendIndicator(
                        outReachData?.current_activity_calls,
                        outReachData?.last_activity_calls,
                      )}
                    </div>
                    <div className="sd-outreach-row">
                      <div className="sd-outreach-left">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.infoSoft,
                            color: COLORS.info,
                          }}
                        >
                          <FiMail size={16} />
                        </div>
                        <div>
                          <h3
                            className="fw-normal text-dark mb-0"
                            style={{ letterSpacing: "-0.02em" }}
                          >
                            {outReachData?.current_followup}
                          </h3>
                          <div className="sd-kpi-label">Follow Ups</div>
                        </div>
                      </div>
                      {renderTrendIndicator(
                        outReachData?.current_followup,
                        outReachData?.last_followup,
                      )}
                    </div>
                    <div className="sd-outreach-row">
                      <div className="sd-outreach-left">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.successSoft,
                            color: COLORS.success,
                          }}
                        >
                          <BsWhatsapp size={14} />
                        </div>
                        <div>
                          <h3
                            className="fw-normal text-dark mb-0"
                            style={{ letterSpacing: "-0.02em" }}
                          >
                            {outReachData?.current_whatsapp}
                          </h3>
                          <div className="sd-kpi-label">WhatsApp</div>
                        </div>
                      </div>
                      {renderTrendIndicator(
                        outReachData?.current_whatsapp,
                        outReachData?.last_whatsapp,
                      )}
                    </div>
                  </div>
                </SectionCard>
              </div>
              <div className="col-lg-4">
                <SectionCard
                  title="Activity Summary"
                  subtitle="Scheduled & pending"
                  icon={<FiBarChart2 size={16} />}
                  accent={COLORS.purple}
                >
                  <div className="sd-activity-grid">
                    <div className="sd-activity-row sd-activity-row-div">
                      <div className="sd-activity-item">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.purpleSoft,
                            color: COLORS.purple,
                            margin: "0 auto 10px",
                          }}
                        >
                          <FiUsers size={16} />
                        </div>
                        <h3
                          className="fw-normal text-dark mb-0"
                          style={{ letterSpacing: "-0.02em" }}
                        >
                          {activitySummary?.current_meeting}
                        </h3>
                        <div className="sd-kpi-label">Meetings</div>
                        {renderActivityTrendIndicator(
                          activitySummary?.current_meeting,
                          activitySummary?.last_meeting,
                        )}
                      </div>
                      <div className="sd-activity-item">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.tealSoft,
                            color: COLORS.teal,
                            margin: "0 auto 10px",
                          }}
                        >
                          <FiMonitor size={16} />
                        </div>
                        <h3
                          className="fw-normal text-dark mb-0"
                          style={{ letterSpacing: "-0.02em" }}
                        >
                          {activitySummary?.current_demo_leads}
                        </h3>
                        <div className="sd-kpi-label">Demos</div>
                        <div
                          className="sd-kpi-trend-mini"
                          style={{
                            color: COLORS.success,
                            justifyContent: "center",
                          }}
                        >
                          {renderActivityTrendIndicator(
                            activitySummary?.current_demo_leads,
                            activitySummary?.last_demo_leads,
                          )}
                        </div>
                      </div>
                      <div className="sd-activity-item">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.infoSoft,
                            color: COLORS.info,
                            margin: "0 auto 10px",
                          }}
                        >
                          <FiUserPlus size={16} />
                        </div>
                        <h3
                          className="fw-normal text-dark mb-0"
                          style={{ letterSpacing: "-0.02em" }}
                        >
                          {activitySummary?.current_leads}
                        </h3>
                        <div className="sd-kpi-label">New Leads</div>
                        {renderActivityTrendIndicator(
                          activitySummary?.current_leads,
                          activitySummary?.last_leads,
                        )}
                      </div>
                    </div>
                    <div className="sd-activity-row">
                      <div className="sd-activity-item">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.warningSoft,
                            color: COLORS.warning,
                            margin: "0 auto 10px",
                          }}
                        >
                          <FiFileText size={16} />
                        </div>

                        <h3
                          className="fw-normal text-dark mb-0"
                          style={{ letterSpacing: "-0.02em" }}
                        >
                          {activitySummary?.current_task}
                        </h3>
                        <div className="sd-kpi-label">Due Tasks</div>
                        {renderActivityTrendIndicator(
                          activitySummary?.current_task,
                          activitySummary?.last_task,
                        )}
                      </div>
                      <div className="sd-activity-item">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.dangerSoft,
                            color: COLORS.danger,
                            margin: "0 auto 10px",
                          }}
                        >
                          <FiCheckCircle size={16} />
                        </div>
                        <h3
                          className="fw-normal text-dark mb-0"
                          style={{ letterSpacing: "-0.02em" }}
                        >
                          {activitySummary?.current_todo}
                        </h3>
                        <div className="sd-kpi-label">Due To-Dos</div>
                        {renderActivityTrendIndicator(
                          activitySummary?.current_todo,
                          activitySummary?.last_todo,
                        )}
                      </div>
                      <div className="sd-activity-item">
                        <div
                          className="sd-kpi-icon"
                          style={{
                            background: COLORS.successSoft,
                            color: COLORS.success,
                            margin: "0 auto 10px",
                          }}
                        >
                          <FiAward size={16} />
                        </div>
                        <h3
                          className="fw-normal text-dark mb-0"
                          style={{ letterSpacing: "-0.02em" }}
                        >
                          {activitySummary?.current_deals}
                        </h3>
                        <div className="sd-kpi-label">Deals Won</div>
                        {renderActivityTrendIndicator(
                          activitySummary?.current_deals,
                          activitySummary?.last_deals,
                        )}
                      </div>
                    </div>
                  </div>
                </SectionCard>
              </div>
              <div className="col-lg-5">
                <MonthlyTargetRadial />
              </div>
            </div>

            {/* Funnel + Pipeline + Lead sources */}
            <div className="row g-3 mb-3">
              <div className="col-lg-4">
                <SalesFunnel
                  data1={salesFunnelData}
                  range={saleFunnelRange}
                  onRangeChange={setSaleFunnelRange}
                />
              </div>
              <div className="col-lg-4">
                <PipelineDistribution
                  pipelines={pipelines}
                  selectedPipeline={selectedPipeline}
                  onPipelineChange={setSelectedPipeline}
                  data={pipelineDistData}
                />
              </div>
              <div className="col-lg-4">
                <LeadSources
                  data={topLeadSourceBySale}
                  range={leadSourceRange}
                  onRangeChange={setLeadSourceRange}
                />
              </div>
            </div>

            {/* Personal KPI's + Win Ratio */}
            <div className="row g-3 mb-3 align-items-stretch">
              <div className="col-lg-8">
                <SectionCard
                  title="Personal KPI's"
                  subtitle="Today's individual performance"
                  icon={<FiUser size={16} />}
                  accent={COLORS.teal}
                >
                  <div className="sd-personal-kpi-list">
                    <div className="sd-personal-kpi-item">
                      <div
                        className="sd-kpi-icon"
                        style={{
                          background: COLORS.primarySoft,
                          color: COLORS.primary,
                          margin: "0 auto 10px",
                        }}
                      >
                        <FiPhoneCall size={18} />
                      </div>
                      <h3
                        className="fw-normal text-dark mb-0"
                        style={{ letterSpacing: "-0.02em" }}
                      >
                        {personalKpiData?.calls}
                      </h3>
                      <div className="sd-kpi-label">Calls Today</div>
                    </div>
                    <div className="sd-personal-kpi-item">
                      <div
                        className="sd-kpi-icon"
                        style={{
                          background: COLORS.infoSoft,
                          color: COLORS.info,
                          margin: "0 auto 10px",
                        }}
                      >
                        <FiMail size={18} />
                      </div>
                      <h3
                        className="fw-normal text-dark mb-0"
                        style={{ letterSpacing: "-0.02em" }}
                      >
                        430
                      </h3>
                      <div className="sd-kpi-label">Emails</div>
                    </div>
                    <div className="sd-personal-kpi-item">
                      <div
                        className="sd-kpi-icon"
                        style={{
                          background: COLORS.purpleSoft,
                          color: COLORS.purple,
                          margin: "0 auto 10px",
                        }}
                      >
                        <FiUsers size={18} />
                      </div>
                      <h3
                        className="fw-normal text-dark mb-0"
                        style={{ letterSpacing: "-0.02em" }}
                      >
                        {personalKpiData?.meeting}
                      </h3>
                      <div className="sd-kpi-label">Meetings</div>
                    </div>
                    <div className="sd-personal-kpi-item">
                      <div
                        className="sd-kpi-icon"
                        style={{
                          background: COLORS.successSoft,
                          color: COLORS.success,
                          margin: "0 auto 10px",
                        }}
                      >
                        <FiMonitor size={18} />
                      </div>
                      <h3
                        className="fw-normal text-dark mb-0"
                        style={{ letterSpacing: "-0.02em" }}
                      >
                        302
                      </h3>
                      <div className="sd-kpi-label">Demos</div>
                    </div>
                    <div className="sd-personal-kpi-item">
                      <div
                        className="sd-kpi-icon"
                        style={{
                          background: COLORS.warningSoft,
                          color: COLORS.warning,
                          margin: "0 auto 10px",
                        }}
                      >
                        <FiRepeat size={18} />
                      </div>
                      <h3
                        className="fw-normal text-dark mb-0"
                        style={{ letterSpacing: "-0.02em" }}
                      >
                        {personalKpiData?.followup}
                      </h3>
                      <div className="sd-kpi-label">Follow Ups</div>
                    </div>
                  </div>
                </SectionCard>
              </div>
              <div className="col-lg-4">
                <SectionCard3>
                  <div className="h-100 d-flex align-items-center justify-content-center">
                    <MiniWinGauge data={win_rate()} size="lg" />
                  </div>
                </SectionCard3>
              </div>
            </div>

            {/* Hot leads + Recent deal */}
            <div className="row g-3 mb-3">
              <div className="col-lg-6">
                <HotLeadsTable
                  data={recentLeadData}
                  range={recentLeadRange}
                  onRangeChange={setRecentLeadRange}
                />
              </div>
              <div className="col-lg-6">
                <RecentDealsTable
                  data={recentDealData}
                  range={recentDealRange}
                  onRangeChange={setRecentDealRange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};